import { createRouter, createWebHistory, useRouter } from "vue-router";
import { ref, Ref } from "vue";
import { useStore } from "@/store/store";
import { Role } from "./domain/User";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "home", component: () => import("@/views/Home.vue") },
    { path: "/login", name: "login", component: () => import("@/views/Login.vue") },
    { path: "/users", name: "users", component: () => import("@/views/AdminUser.vue") },
    { path: "/tags", name: "tags", component: () => import("@/views/AdminTags.vue") },
    { path: "/cardnum", name: "cardnum", component: () => import("@/views/CardNum.vue") },
    { path: "/root", name: "root", component: () => import("@/views/RootAdmin.vue") },
    { path: "/schooladmin", name: "admin", component: () => import("@/views/Admin.vue") },
  ],
});

export const jumpHomeIfNot = (roles: Role[]): Ref<boolean> => {
  const store = useStore();
  const router = useRouter();

  if (!roles.includes(store.state.user.role)) {
    router.push("/");
    return ref(false);
  }
  return ref(true);
};
